var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"wrapper"},[_c('el-header',[_c('HeaderDom')],1),_vm._v(" "),_c('el-container',[_c('el-main',{staticClass:"content-box"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-y"},[_c('div',{staticClass:"content-main"},[_c('router-view')],1)])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09f480a7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/module/Module.vue
// module id = null
// module chunks = 